import React from "react";
import {Spinner } from "reactstrap";
import { useTranslation } from "react-i18next";

const TableHelper = ({ loading, error, padding }) => {
  const { t } = useTranslation();
  return (
    <>
      {loading ? (
        <div className="tableHelper" style={{padding: padding ? "20px" : 0}} >
          <p style={{ color: "#000a60" }}>{t("general.tableHelper.loading")}</p>
          <Spinner size="sm" color="primary" />
        </div>
      ) : error ? (
        <div className="tableHelper">
          <p style={{ color: "#f62d51" }}>{t("general.tableHelper.error")}</p>
        </div>
      ) : (
        <div className="tableHelper" style={{flexDirection: 'column', alignItems: 'flex-start'}}>
          <p style={{ color: "#000a60" }}>{t("general.tableHelper.noData")}</p>
        </div>
      )}
    </>
  );
};

export default TableHelper;
